// extracted by mini-css-extract-plugin
export default {"mapContainer":"MapPage_mapContainer__SsCWJ","mapControls":"MapPage_mapControls__wwJ+L","providerDetails":"MapPage_providerDetails__gJkww"};